<script lang="ts">
    // import { afterUpdate } from "svelte";

    // export let categories: any;
    export let urlPath: string;
    export let generateCategoryURL: any;
    export let categoriesV2Filtered: any;
</script>

<div
    class="h-auto z-20 3xs:top-[13rem] xs:top-[9rem] sm:top-[7rem] md:top-[7rem] lg:top-[7rem] xl:top-[4rem] !bg-white p-3 right-0 absolute flex flex-col gap-2 overflow-auto border rounded-lg"
    style="scrollbar-width: thin; scrollbar-color: rgba(155, 155, 155, 0.5) transparent;"
>
    {#each categoriesV2Filtered?.slice(3, 100) as category}
        <a
            data-sveltekit-reload="off"
            href={`/news/categories/${category?.slug}/`}
            class={`
                ${urlPath === generateCategoryURL(category) ? "bg-slate-100 font-semibold rounded-md" : ""}
                no-underline hover:no-underline hover:bg-slate-100 hover:rounded-md !px-4 py-2 transition-all text-[17px] text-slate-700 font-normal item-category w-full 
            `}
        >
            <span>{category?.name}</span>
        </a>
    {/each}
</div>
